import {
  SetBookmarkDataAPI,
  SET_BOOKMARK_DATA,
  SetBookmarkAPI,
  SET_BOOKMARK,
  Exceptions,
  DeleteBookmarksAPI,
  DELETE_BOOKMARKS,
  DeleteCollectionAPI,
  DELETE_COLLECTION,
  EditCollectionAPI,
  EDIT_COLLECTION,
  CreateCollectionAPI,
  CREATE_COLLECTION,
  GET_COLLECTIONS,
  GetCollectionsAPI,
  GetBookmarksAPI,
  GET_BOOKMARKS,
} from '@weblite-wapps/protocol'
import { setWappBookmarkData } from 'weblite-web-wapprunner'
import { wappSubscription } from '$logic/wapp-communication/helper/subscription-handler'
import { showBookmarkSelectionListModal } from '$comp/modals/bookmark-selection-list-modal'
import {
  deleteBookmark,
  deleteCollection,
  getCollectionBookmarks,
  getCollections,
  getContentCollection,
} from '$logic/bookmark'
import { showCreateBookmarkCollectionModal } from '$comp/modals/create-bookmark-collection-modal'

wappSubscription.subscribe<SetBookmarkDataAPI>(
  SET_BOOKMARK_DATA,
  (payload, meta) => {
    setWappBookmarkData(meta.wappSessionId, payload)
    return { status: 'ok' }
  },
)

wappSubscription.subscribe<SetBookmarkAPI>(SET_BOOKMARK, async bookmarkData => {
  const oldCollections = await getContentCollection(bookmarkData.contentUri)
  const affected = await new Promise(onDone =>
    showBookmarkSelectionListModal({ bookmarkData, oldCollections, onDone }),
  )
  if (affected) return { status: 'ok' }

  return { errorCode: Exceptions.TEMPORARILY_NOT_AVAILABLE }
})

wappSubscription.subscribe<DeleteBookmarksAPI>(
  DELETE_BOOKMARKS,
  async payload => {
    const affected = await deleteBookmark(payload.bookmarks)
    if (affected) return { status: 'ok' }

    return { errorCode: Exceptions.TEMPORARILY_NOT_AVAILABLE }
  },
)

wappSubscription.subscribe<DeleteCollectionAPI>(
  DELETE_COLLECTION,
  async payload => {
    const affected = await deleteCollection(payload.title)
    if (affected) return { status: 'ok' }

    return { errorCode: Exceptions.TEMPORARILY_NOT_AVAILABLE }
  },
)

wappSubscription.subscribe<CreateCollectionAPI>(CREATE_COLLECTION, async () => {
  const affected = await new Promise(onDone =>
    showCreateBookmarkCollectionModal({ onDone }),
  )
  if (affected) return { status: 'ok' }

  return { errorCode: Exceptions.TEMPORARILY_NOT_AVAILABLE }
})

wappSubscription.subscribe<EditCollectionAPI>(
  EDIT_COLLECTION,
  async payload => {
    const affected = await new Promise(onDone =>
      showCreateBookmarkCollectionModal({ onDone, oldTitle: payload.title }),
    )
    if (affected) return { status: 'ok' }

    return { errorCode: Exceptions.TEMPORARILY_NOT_AVAILABLE }
  },
)

wappSubscription.subscribe<GetCollectionsAPI>(GET_COLLECTIONS, async () => {
  const collections = await getCollections()
  return { collections }
})

wappSubscription.subscribe<GetBookmarksAPI>(GET_BOOKMARKS, async payload => {
  const bookmarks = await getCollectionBookmarks(payload.title)
  return { bookmarks }
})
